module.exports = __webpack_public_path__ + "img/17.68d6832e.webp";